export enum IauiVerificationModalState {
	OPEN,
	CLOSED,
}

export interface IauiVerificationState {
	modalState: IauiVerificationModalState;
	selectedPayment: string | undefined;
	dismissed: boolean;
	isInProgress: boolean;
}
